import React, { useContext, useEffect, useState } from 'react';
import MenuItem from 'shared/components/MenuItem'
import { Nav } from 'react-bootstrap'
import MenuItemCollapse from 'shared/components/MenuItemCollapse'
import MenuItemDropdown from 'shared/components/MenuItemDropdown'
import MenuItemLogout from 'shared/components/MenuItemLogout'
import useInit from './hooks/useInit'
import useGetCurrentPage from './hooks/useGetCurrentPage'
import hasViewMode from 'shared/utils/hasViewMode';

interface MenuProps {
    position?: String | boolean | undefined
    showLogOut?: boolean
    bottomInsert?: React.FunctionComponent | React.ReactElement | string | false
    menuId?: number | false
}

const Menu: React.FunctionComponent<MenuProps> = (props) => {

    const [pages, setPages] = useState<any>([])
    const [currentPage, setCurrentPage] = useState<any>([])

    useInit({
        setPages,
        position: props.position,
    })

    useGetCurrentPage({
        setCurrentPage
    })

    return (
        <Nav className="justify-content-end" key={'menu-' + props.position + '-' + props.menuId}>
            {pages.map((itemProps: any, key: number | string) => {
                if ((itemProps.showInMenu === props.position) &&
                    (itemProps.parentPath === undefined) &&
                    (itemProps.roles === undefined || hasViewMode(itemProps.roles))) {
                    return (
                        <>
                            {!itemProps.isDropdown &&
                                <MenuItem
                                    key={itemProps.name + '-' + key}
                                    label={itemProps.name}
                                    link={itemProps.path}
                                    icon={itemProps.icon}
                                    iconActive={itemProps.iconActive}
                                    pages={pages}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    id={itemProps.id}
                                />}
                            {(itemProps.showInMenu === 'left') && itemProps.isDropdown &&
                                <MenuItemCollapse
                                    key={itemProps.name + '-' + key + '-dd'}
                                    label={itemProps.name}
                                    link={itemProps.path}
                                    pages={pages}
                                    icon={itemProps.icon}
                                    iconActive={itemProps.iconActive}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />}
                            {(itemProps.showInMenu === 'top') && itemProps.isDropdown &&
                                <MenuItemDropdown
                                    key={itemProps.name + '-' + key + '-dd'}
                                    label={itemProps.name}
                                    link={itemProps.path}
                                    pages={pages}
                                />}
                        </>
                    )
                }
            })}
            {props.bottomInsert && <li className='menu-item bottom-insert'>{props.bottomInsert}</li>}
            {props.showLogOut && <MenuItemLogout />}
        </Nav>
    );
}

export default Menu